/*
 * The Belgian Brewer: "Are you 18 or over?" dialog (sections/tbb-age-gate.liquid).
 * Opens once per visitor; "Yes" sets a first-party cookie for the chosen number of days and closes it,
 * "Exit" is a plain link off the site. Escape doesn't dismiss it: an answer is needed.
 * In the theme editor it only opens while the section is selected.
 */
const COOKIE = 'tbb_age_ok';

const confirmed = () => document.cookie.split('; ').some((c) => c === `${COOKIE}=1`);

function remember(days) {
  const maxAge = Math.max(1, Number(days) || 30) * 86400;
  document.cookie = `${COOKIE}=1; max-age=${maxAge}; path=/; SameSite=Lax`;
}

function open(dialog) {
  if (dialog.open) return;
  if (typeof dialog.showModal === 'function') dialog.showModal();
  else dialog.setAttribute('open', '');
}

function close(dialog) {
  if (typeof dialog.close === 'function') dialog.close();
  else dialog.removeAttribute('open');
}

function setUp(dialog) {
  if (dialog.dataset.tbbReady) return;
  dialog.dataset.tbbReady = 'true';

  dialog.addEventListener('cancel', (event) => event.preventDefault());
  // Browsers may still close it on Escape (no user activation yet): reopen unless Yes was chosen.
  dialog.addEventListener('close', () => {
    if (dialog.dataset.tbbAllowClose) {
      delete dialog.dataset.tbbAllowClose;
      return;
    }
    if (!confirmed()) requestAnimationFrame(() => open(dialog));
  });
  dialog.querySelector('[data-tbb-age-yes]')?.addEventListener('click', () => {
    remember(dialog.dataset.days);
    close(dialog);
  });

  if (window.Shopify?.designMode) return;
  if (!confirmed()) open(dialog);
}

const init = (root = document) => root.querySelectorAll('[data-tbb-age]').forEach(setUp);
init();

// Theme editor: show it while the section is selected, hide it otherwise.
document.addEventListener('shopify:section:load', (event) => init(event.target));
document.addEventListener('shopify:section:select', (event) => {
  const dialog = event.target.querySelector('[data-tbb-age]');
  if (dialog) open(dialog);
});
document.addEventListener('shopify:section:deselect', (event) => {
  const dialog = event.target.querySelector('[data-tbb-age]');
  if (!dialog) return;
  dialog.dataset.tbbAllowClose = 'true';
  close(dialog);
});
